import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnWhite from '../Buttons/BtnWhite';
import BtnSubmit from '../Buttons/BtnSubmit';
import PopUp from '../Popup/PopUp';
import coockiesImg from './images/coockies.svg';
import {navigateTo} from '../../../utilities/StringHelpers/StringHelpers';

const cookiesPopup = (props) => {
  const [isShowCookiesPopup, setIsShowCookiesPopup] = useState(false);

  useEffect(() => {
    getIsShowCookiesPopup();
  }, []);

  const getIsShowCookiesPopup = () => {
    try {
      const parentDomain = window.parent.location.hostname;
      const parentUrl = window.parent.location.href;
      if (parentDomain || parentUrl) {
        setIsShowCookiesPopup(true);
      }
    } catch (error) {}
  };

  const acceptCookies = () => {
    if (window.localStorage) {
      localStorage.setItem('isCookiesAccepted', 'true');
      setIsShowCookiesPopup(false);
    }
  };

  const moreInformationLinkClicked = () => {
    acceptCookies();
    if (props.termsPolicyLink) {
      navigateTo(props.termsPolicyLink);
    }
  };

  let cookiesPopupComponent = (
    <div className='cookies-popup-wrapper'>
      <PopUp showPopUp={isShowCookiesPopup} onClose={() => acceptCookies()} preventWrapperClose>
        <div className='content'>
          <Image src={coockiesImg} className='Coockies' />
          <div className='text-wrapper'>
            <p className='inner_text'>
              לידיעתך, אנו משתמשים בעוגיות (Cookies) באתר זה. &nbsp;
              <a onClick={() => moreInformationLinkClicked()} className='additional-info-link'>
                לפרטים נוספים
              </a>
            </p>
            <div className='btn-holder'>
              <BtnSubmit text='סגירה' onclick={() => acceptCookies()} />
            </div>
          </div>
        </div>
      </PopUp>
    </div>
  );

  return cookiesPopupComponent;
};
export default cookiesPopup;
